<template>
  <div id="crTooltip">
    <!-- 点击复制的提示 -->
    <a-tooltip :getPopupContainer="getPopupContainer" :placement="placement" title="点击复制">
      <slot></slot>
    </a-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    placement: {
      type: String,
      default: 'topLeft'
    }
  },
  methods: {
    getPopupContainer() {
      return document.getElementById('crTooltip')
    }
  }
}
</script>
<style lang="less" scoped>
#crTooltip {
  display: inline-block;
}
/deep/.ant-tooltip {
  .ant-tooltip-inner {
    color: #47ba97;
    background-color: #fff;
    border: 1px solid #47ba97;
    cursor: pointer;
    width: 72px !important;
    height: 24px !important;
    min-height: unset;
    padding: 0 7px;
    &:hover {
      color: #fff;
      background-color: #47ba97;
    }
  }
  .ant-tooltip-arrow::before {
    display: none;
    background-color: #47ba97;
  }
}
</style>
